<template>
  <el-container>
    <el-main style="padding: 0">
      <div>
        <span>生产入库扫描</span>
        <el-divider/>
        <el-form ref="form" class="form" label-width="80px">
          <el-form-item label="产品编号" prop="sn" style="width: 500px">
            <el-input ref="snInput" v-model.trim="sn" placeholder="请扫描产品编号" @keyup.enter.native="snInput"/>
          </el-form-item>
          <el-form-item label="入库详情">
            <el-table :data="tableData" border>
              <el-table-column align="center" type="index" label="#" width="50"/>
              <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
              <el-table-column prop="materialName" align="left" min-width="400" label="物料名称"/>
              <el-table-column align="left" label="库位" min-width="200">
                <template slot-scope="scope">
                  <el-form-item class="locationSelect">
                    <el-input v-model="scope.row.locationName" placeholder="请选择" @keyup.enter.native="scanLocationCode($event,scope.row)">
                      <el-button slot="append" @click="chooseLocation(scope.$index)"> 选择 </el-button>
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item>
            <el-button type="info" @click="reset">重置</el-button>
            <el-button :loading="submitLoading" type="primary" @click="scanHandle">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
      <warehouse-select ref="warehouseSelect" @select="kwSelect"/>
    </el-main>
  </el-container>
</template>

<script>
  import WarehouseSelect from "@/views/information/WarehouseNew/WarehouseSelect";
  export default {
    name: "ProductionStoreScanIndex",
    components: { WarehouseSelect },
    data() {
      return {
        index: "",
        sn: "",
        tableData: [],
        submitLoading: false,
      };
    },
    mounted() {
      this.$refs.snInput.focus();
    },
    methods: {
      // 扫描产品编号
      snInput() {
        if (this.sn) {
          // 校验条码是否存在
          this.$http.get("basic", `scanRecords/SCRK_Check/${this.sn}`).then((resp) => {
            if (resp.success) {
              //MQ开头 12位长度
              if ((this.sn.substr(0, 2) === "MQ") & (this.sn.length === 12)) {
                this.codeMQ();
              //V开头5位
              } else if ((this.sn.substr(0, 1) === "V") & (this.sn.length === 5)) {
                this.codeVehicle();
              } else {
                this.codeNotContainMQ();
              }
            } else {
              this.sn = "";
            }
          });
        }
      },
      // 条码已MQ开头
      codeMQ() {
        this.$http.get("basic", `materialVehicleQuantities/getByBatchRowNo/${this.sn}`).then((resp) => {
          this.tableData = [];
          resp.data.forEach((item) => {
            let data = {
              materialId: item.materialId,
              materialNo: item.materialNo,
              materialName: item.materialName,
              locationId: item.locationId,
              locationName: "",
            };
            this.tableData.push(data);
          });
        });
      },
      // 非MQ开头的条码 不包含载具条码
      codeNotContainMQ() {
        this.$http.get("basic", `snSerialNos/getListBySerialNo/${this.sn}`).then((resp) => {
          this.tableData = [];
          resp.data.forEach((item) => {
            let data = {
              materialId: item.materialId,
              materialNo: item.materialNo,
              materialName: item.materialName,
              locationId: item.locationId,
              locationName: "",
            };
            this.tableData.push(data);
          });
        });
      },
      //条码为载具编号
      codeVehicle() {
        this.$http.get("basic", `materialVehicleQuantities/getByVehicleNo/${this.sn}`).then((resp) => {
          this.tableData = [];
          resp.data.forEach((item) => {
            let data = {
              materialId: item.materialId,
              materialNo: item.materialNo,
              materialName: item.materialName,
              locationId: item.locationId,
              locationName: "",
            };
            this.tableData.push(data);
          });
        });
      },
      // 选择库位(支持选择、扫描)
      chooseLocation(index) {
        this.index = index;
        this.$refs.warehouseSelect.open();
      },
      kwSelect(row) {
        this.tableData[this.index].locationId = row.pkid;
        this.tableData[this.index].locationName = row.name;
      },
      // 扫描库位编号
      scanLocationCode(e,currentRow) {
        if(e.target.value) {
          this.$http.get("basic",`warehouses/getByCode/${e.target.value}`).then(res => {
            if(res.success) {
              currentRow.locationId = res.data.pkid;
              currentRow.locationName = res.data.name;
            }
          });
        }
      },
      // 确认
      scanHandle() {
        if (!this.sn) {
          this.$confirm("产品编号不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        const arr = this.tableData.filter((item) => !item.locationId);
        if (arr.length) {
          this.$confirm("库位不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.submitLoading = true;
        this.$http.post("basic", `scanRecords/SCRK_Scan/${this.sn}`, this.tableData).then((res) => {
          if (res.success) {
            this.$message.success("入库成功");
            this.reset();
          }
          this.submitLoading = false;
        }).catch(() => {
          this.submitLoading = false;
        });
      },
      // 重置
      reset() {
        this.sn = "";
        this.tableData = [];
        this.$refs.snInput.focus();
      },
    },
  };
</script>

<style scoped>
.locationSelect.el-form-item.el-form-item--mini {
  margin-bottom: 0;
}
</style>
